import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchHelpIndex, sendSupportMessage } from "@/lib/api/help";

export function useHelpIndex(enabled: boolean) {
  return useQuery({
    queryKey: ["help", "index"],
    queryFn: fetchHelpIndex,
    enabled,
    staleTime: 60 * 60 * 1000,
  });
}

export function useSendSupport() {
  return useMutation({ mutationFn: sendSupportMessage });
}
